import DOMPurify from 'dompurify';
import { Copy, FileText, Pencil } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

import type { PeticaoModelo } from './ModelosPage';

interface ModeloViewDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  modelo: PeticaoModelo | null;
  onEdit: (modelo: PeticaoModelo) => void;
  onDuplicate: (modelo: PeticaoModelo) => void;
}

export function ModeloViewDialog({ open, onOpenChange, modelo, onEdit, onDuplicate }: ModeloViewDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-full sm:max-w-2xl max-h-[90vh] flex flex-col">
        <DialogHeader>
          <div className="flex items-center gap-4">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
              <FileText className="h-5 w-5" />
            </div>
            <DialogTitle>{modelo?.titulo}</DialogTitle>
          </div>
        </DialogHeader>
        <div
          className="min-h-[200px] leading-relaxed overflow-y-auto flex-1 [&_h1]:mt-6 [&_h1]:mb-4 [&_h2]:mt-6 [&_h2]:mb-4 [&_h3]:mt-6 [&_h3]:mb-4 [&_ol]:mb-4 [&_ol]:pl-6 [&_p]:mb-4 [&_ul]:mb-4 [&_ul]:pl-6"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(modelo?.corpo || '<p>Modelo sem conteúdo</p>') }}
        />
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>
            Fechar
          </Button>
          <Button
            variant="outline"
            onClick={() => modelo && onDuplicate(modelo)}
          >
            <Copy className="mr-2 h-4 w-4" />
            Duplicar
          </Button>
          {/* Sempre: modelo do sistema/compartilhado é editado numa cópia do usuário. */}
          {modelo && (
            <Button
              onClick={() => {
                onOpenChange(false);
                onEdit(modelo);
              }}
            >
              <Pencil className="mr-2 h-4 w-4" />
              Editar
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
